import React from 'react';

const VisionSection = () => {
  return (
    <section className="vision-section section-container">
      <div className="section-header">
        <h2 className="section-title">Una visión compartida</h2>
      </div>

      <div className="vision-content">
        <div className="vision-founders-photo">
          <img 
            src="https://customer-assets.emergentagent.com/job_keeper-elite/artifacts/tuvxzvkj_IMG_9992.jpeg" 
            alt="Edgar Merino y Christiane Endler"
            className="founders-image"
          />
          <p className="founders-caption">Edgar Merino & Christiane Endler</p>
        </div>

        <p className="vision-text">
          The Keeper Lab nace de años de conversaciones entre representante y arquera.
        </p>

        <p className="vision-text">
          De entender que incluso llegando a lo más alto — Champions League, premios individuales, 
          reconocimiento mundial — el arquero sigue necesitando algo diferente.
        </p>

        <div className="vision-needs">
          <p className="vision-need">Estructura.</p>
          <p className="vision-need">Comprensión.</p>
          <p className="vision-need">Defensa estratégica fuera del campo.</p>
        </div>

        <p className="vision-conclusion highlight">
          Este proyecto es la respuesta a ese vacío.
        </p>
      </div>
    </section>
  );
};

export default VisionSection;
